import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = location.hash.split("session_id=")[1]?.split("&")[0];
    if (!sessionId) {
      navigate("/connexion", { replace: true });
      return;
    }
    api.post("/auth/google/session", { session_id: sessionId })
      .then((res) => {
        setUser(res.data);
        // Nettoyer le hash puis rester sur la page de retour (le panier survit via localStorage)
        window.history.replaceState(null, "", window.location.pathname);
        navigate(window.location.pathname, { replace: true });
      })
      .catch(() => navigate("/connexion", { replace: true }));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div data-testid="auth-callback" className="min-h-screen flex items-center justify-center">
      <Loader2 className="w-10 h-10 text-gold animate-spin" />
    </div>
  );
}
